import TabsData from "./types/tabs-data";

const getContent = (tabsData: TabsData, activeIndex: number) =>
  tabsData.find((tab, index) => index === activeIndex)!.content;

const tabsHelper = { getContent };

export default tabsHelper;
